import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-167" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-primary/25 border-l-4 border-l-primary bg-background/90 p-4 pr-10 text-foreground shadow-2xl shadow-black/50 backdrop-blur-md" aria-live="polite" data-id="element-168" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" aria-label="Chiudi avviso" data-id="element-169" data-mp="1sfmsj9nfkp8d">
            <XIcon className="h-4 w-4" data-id="element-170" data-mp="1ngjl5ijza6x8" />
          </button>
          <div className="flex gap-3" data-id="element-171" data-mp="1nf05nu65bzwi">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary drop-shadow-glow" aria-hidden="true" data-id="element-172" data-mp="19poiwp3zio2m" />
            <div data-id="element-173" data-mp="1egeni04l6mw9">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-primary" data-id="element-174" data-mp="1egwspm988bgb">Accesso confermato</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-175" data-mp="zt1yu2jhg11n">
                Una volta completato l&apos;acquisto riceverai la
                <br data-id="element-176" data-mp="qqkghz6y7sjx" />
                <span className="font-bold text-foreground" data-id="element-177" data-mp="qqaknuz82r6b">GESTIONE AMBIENTALE — Edizione Docenti</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-178" data-mp="voc5olg7l0kf">Accesso digitale immediato via email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}